<div id="container" (mouseenter)="tooltip.onHover()" (mouseleave)="tooltip.onExit()" *ngIf="tooltip.type === 'flagEditor'
 && tooltip.flaggableObject" (contextmenu)="$event.preventDefault()" [style]="positionStyle">
  <div id="status" class="flag-container" [style]="'color:' +
  (tooltip.flaggableObject.flagged ? flagService.getColor(tooltip.flaggableObject.flagColor) : '#444444') + ';'"
  (click)="removeFlag()">
    <i class="fas fa-ban"></i>
  </div>
  <div *ngFor="let flagColor of flagService.flagColorKeys;let i = index" class="flag-container selectable-flag"
       [style]="'color: ' + flagService.getColor(i) + '; grid-column: ' + i + ';'"
  (click)="setColor(i)">
    <i class="fas fa-flag"></i>
  </div>
</div>
